const Config = {
  apiEndPoint: "/arp-api/v1",
  privacyPolicy: "https://www.radisys.com/privacy",
  TermsofService: "https://www.engagedigital.ai/hackathon-terms-and-conditions",
  maxTeamSize: 10,
  copyrightYear: 2022,
};

export default Config;